/**
 * Formats a commission rate stored as a fraction (e.g. 0.025) into a
 * human-readable percentage string (e.g. "2.5%").
 *
 * Shows up to three decimal places and trims trailing zeros, so whole
 * percentages stay clean (0.03 -> "3%") while fractional rates are no longer
 * rounded away (0.025 -> "2.5%" instead of "3%").
 */
export const formatCommissionRate = (rate?: number): string => {
  const numRate = Number(rate ?? 0) * 100;
  // toFixed(3) caps the precision and rounds; Number() strips trailing zeros.
  const rounded = Number(numRate.toFixed(3));
  return `${rounded}%`;
};
